import { handleActions } from 'redux-actions'
import {
  FETCH_TOUR_INIT,
  FETCH_TOUR_DONE,
  UPDATE_TOUR,
  START_TOUR,
  DISABLE_TOUR_BUTTON,
  ENABLE_TOUR_BUTTON,
  CHANGE_TOUR_ACTIVE,
  RUN_TOUR,
  ASPIRE_INTRO_SCREEN_STATUS,
  UPDATE_ASPIRE_INTRO_SCREEN,
} from './Action.js'
import $ from 'jquery'

const initialState = {
  startTour: false,
  tourStatus: null,
  showTourButton: true,
  tourActive: false,
  isRunTour: false,
  showAspireIntroScreen: false,
}

export const tour = handleActions(
  {
    [FETCH_TOUR_INIT]: (state, action) => {
      let newState = $.extend(true, {}, state)
      return newState
    },

    [FETCH_TOUR_DONE]: {
      next(state, action) {
        let newState = $.extend(true, {}, state)
        newState.tourStatus = action.payload
        return newState
      },
      throw(state, action) {
        let newState = $.extend(true, {}, state)
        return newState
      },
    },

    [UPDATE_TOUR]: {
      next(state, action) {
        let newState = $.extend(true, {}, state)
        newState.tourStatus = action.payload
        return newState
      },
    },

    [START_TOUR]: {
      next(state, action) {
        let newState = $.extend(true, {}, state)
        newState.startTour = action.payload
        return newState
      },
    },

    [ENABLE_TOUR_BUTTON]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.showTourButton = true
      return newState
    },

    [DISABLE_TOUR_BUTTON]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.showTourButton = false
      return newState
    },

    [CHANGE_TOUR_ACTIVE]: (state, action) => {
      let newState = $.extend(true, {}, state)
      newState.tourActive = action.payload
      return newState
    },

    [RUN_TOUR]: {
      next(state, action) {
        let newState = $.extend(true, {}, state)
        newState.isRunTour = action.payload
        return newState
      },
    },

    [ASPIRE_INTRO_SCREEN_STATUS]: (state, action) => {
      return {
        ...state,
        showAspireIntroScreen: action.payload,
      }
    },

    [UPDATE_ASPIRE_INTRO_SCREEN]: (state, action) => {
      return {
        ...state,
        showAspireIntroScreen: false,
      }
    },
  },
  initialState
)
